module.exports = __webpack_public_path__ + "static/media/04.8c7f710b.png";